// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"q4-z"};